const WHITES = {
  1: '#fff',
  2: '#fbfbfb',
  3: '#f6f6f9',
  4: '#ededed',
  5: '#e9ecef',
  6: '#f8faff',
  7: '#f4f7fa',
  8: '#f1fff1',
  9: '#f3f4f6',
  10: '#f3faff',
  11: '#ecf2fa',
  12: '#cfd4db',
  13: '#ebf0f5',
  14: '#f3f7f9',
  15: '#f3f6f9',
  16: '#eef1f4'
};

const BLACKS = {
  1: '#1a1a1a',
  2: '#000000',
  3: '#1c1c1c'
};

const BLUES = {
  1: '#0046ff',
  2: '#6e777d',
  3: '#323fff',
  4: '#1441a6',
  5: '#002b9e',
  6: '#1256fd',
  7: '#007aff',
  8: '#1b54eb',
  9: '#0249d3',
  10: '#000cb7',
  11: '#436AD0',
  12: '#0F2C67'
};

const REDS = {
  1: '#ff3650',
  2: '#b31a05',
  3: '#e72106',
  4: '#d22008',
  5: '#b81a04',
  6: '#bb2510',
  7: '#FFF2F0',
  8: '#FFCCC7'
};

const ORANGES = {
  1: '#e6a9a1',
  2: '#f8ecea'
};

const GREYS = {
  1: '#4a4a4a',
  2: '#9ba2a7',
  3: '#d7dbdf',
  4: '#4b5359',
  5: '#adcad9',
  6: '#d4d9de',
  7: '#545454',
  8: '#e1e0e0',
  9: '#f0f2f3',
  10: '#666b6f',
  11: '#e1ebf5',
  12: '#454545',
  13: '#29303d',
  14: '#4A4A4A',
  15: '#d0d0d0',
  16: '#424751',
  17: '#545E64',
  18: '#5E6970'
};

const GREENS = {
  1: '#00c500',
  2: '#2ecc71',
  3: '#4d7894',
  4: '#19c027',
  5: '#008e7c',
  6: '#19a203',
  7: '#27a327',
  8: '#008271'
};

export const COLORS = {
  WHITES,
  BLACKS,
  BLUES,
  REDS,
  GREYS,
  GREENS,
  ORANGES
};
